import { AboutUsScreen } from "./AboutUsScreen";

export default AboutUsScreen;
